import Papa from "papaparse";
import { html, utl_parseData } from "../base/_utils";
import "../base/_jquery-global";
import "bootstrap-table";
import "bootstrap/js/dist/dropdown";

// const dataWrapper = document.querySelector("#donationTracker");

async function getAndDisplayData() {
    const tableData = "https://docs.google.com/spreadsheets/d/e/2PACX-1vQJA3WFzEEg6knwBQAuDHUPHKpflzg0DDftmqHBSHjAXPDtS4scKqkGHCv1r0PybYPSJIAB09po2ztI/pub?gid=0&single=true&output=csv";

    try {
        // Fetch and parse the data
        const results = await utl_parseData(tableData, Papa);
        const data = results.data;
        let $table = $("#membership-listing-table");

        $(function () {
            $table.bootstrapTable({
                pagination: true,
                search: true,
                data: data,
            });
        });
    } catch (error) {
        // Handle errors
        console.error("Error parsing data:", error);
    }
}

getAndDisplayData();
